export const UltimosNumerosTarjetaFormat = (sus) => {
    const nums = /\d+/;
    return sus.Tarjeta ? sus.Tarjeta?.split('-')[0] + ' | ●●●● ' + sus.Tarjeta.match(nums)[0] : "";
};